import styled, { css } from 'styled-components'

// Common components
import { Box, FlexBox } from './Box'
import Title from './Title'

// Themes, assets
import { ZIndex } from '../../themes/Metrics'
import { px2Rem } from '../../themes/Mixins'
import TYPOGRAPHY from '../../themes/Typography'
import COLORS from '../../themes/Colors'
import ICON from '../../themes/Icon'

export const Backdrop = FlexBox.extend`
  background-color: ${COLORS.bgBackdrop};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${ZIndex.modal};
  justify-content: center;
  flex-direction: column;
  align-content: center;
  ${props => css`${props.style}`};
`

export const Dialog = Box.extend`
  background-color: ${COLORS.bgDialog};
  position: relative;
  z-index: ${ZIndex.modal};
  color: ${COLORS.colorDialog};
  font-family: ${TYPOGRAPHY.TYPE.light};
  padding: ${px2Rem(35)} ${px2Rem(20)} ${px2Rem(15)};
  width: ${props => props.size === 'large' ? 'auto' : '50%'};
  ${props => css`${props.style}`};

  @media (min-width: 768px) {
    padding: ${px2Rem(40)} ${px2Rem(60)};
  }
`

export const Close = styled.button`
  border: none;
  background: transparent url(${ICON.close}) no-repeat;
  background-size: ${px2Rem(15)} ${px2Rem(16)};
  width: ${px2Rem(15)};
  height: ${px2Rem(16)};
  position: absolute;
  cursor: pointer;
  top: ${px2Rem(10)};
  right: ${px2Rem(18)};
  z-index: ${ZIndex.modal};
  display: ${props => props.hideCloseIcon ? 'none' : 'initial'};
  ${props => css`${props.style}`};

  &:focus {
    outline: none;
  }

  @media (min-width: 768px) {
    top: ${px2Rem(24)};
    right: ${px2Rem(15)};
    display: block;
  }
`

export const ModalTitle = Title.extend`
  margin-bottom: ${px2Rem(20)};
  font-family: ${TYPOGRAPHY.TYPE.light};
  font-size: ${TYPOGRAPHY.SIZE.xSmall};
  color: ${COLORS.titleDialog};
  text-align: center;

  @media (min-width: 768px) {
    font-size: ${TYPOGRAPHY.SIZE.large};
    text-align: left;
  }
`



// WEBPACK FOOTER //
// ./src/components/common/ModalResponsive.js